import React from 'react';
import PropTypes from 'prop-types';
import SqcRow from 'equipmentComponents/SqcRow';
import SqcCertificateScore from 'equipmentComponents/SqcCertificateScore';
import Paper from 'material-ui/Paper';
import {FormattedRelative} from 'react-intl';
import DownArrow from 'material-ui/svg-icons/navigation/arrow-downward';
import UpArrow from 'material-ui/svg-icons/navigation/arrow-upward';
const SqcPanel = (props) => {

    const {sqc} = props;

    const iconStyle = {
        height: '20px',
        width: '20px'
    };

    const paperStyle = {
        padding: '5px'
    };
    const certificate = sqc.getIn(['data', 'certificate']);

    let noCertificateMessage = null;
    if (!certificate) {
        noCertificateMessage = (
            <h6>No Scores Found</h6>
        );
    }

    return (
        <div>
            <div className="row">
                <div className="col s12">
                    <h5>
                        {sqc.getIn(['data', 'modem_info', 'vendor'])}-{sqc.getIn(['data', 'modem_info', 'model'])}
                        <small
                            style={{
                            paddingLeft: '10px',
                            fontSize: '12px'
                        }}>
                            Loaded &nbsp;
                            <FormattedRelative value={sqc.getIn(['created']) || new Date()}/></small>
                    </h5>
                </div>

            </div>

            <div className="row">

                <div className="col s12">
                    <Paper style={paperStyle}>
                        <h5><UpArrow style={iconStyle}/>Upstream</h5>
                        {noCertificateMessage}
                        <div className="row center-align">

                            <SqcCertificateScore
                                colClass="col s4"
                                label="Power"
                                certificateKey="upstream"
                                certificateProperty="power"
                                certificate={sqc.getIn(['data', 'certificate', 'rf'])}/>

                            <SqcCertificateScore
                                colClass="col s4"
                                label="SNR"
                                certificateKey="upstream"
                                certificateProperty="snr"
                                certificate={sqc.getIn(['data', 'certificate', 'rf'])}/>

                            <SqcCertificateScore
                                colClass="col s4"
                                label="CMTSRX"
                                certificateKey="upstream"
                                certificateProperty="cmtsrx"
                                certificate={sqc.getIn(['data', 'certificate', 'rf'])}/>

                        </div>
                    </Paper>
                </div>
            </div>
            <div className="row">
                <div className="col s12">
                    <Paper style={paperStyle}>
                        <h5>
                            <DownArrow style={iconStyle}/>
                            Downstream
                        </h5>
                        {noCertificateMessage}
                        <div className="row center-align">

                            <SqcCertificateScore
                                colClass="col s4"
                                label="Power"
                                certificateKey="downstream"
                                certificateProperty="power"
                                certificate={sqc.getIn(['data', 'certificate', 'rf'])}/>

                            <SqcCertificateScore
                                colClass="col s4"
                                label="SNR"
                                certificateKey="downstream"
                                certificateProperty="snr"
                                certificate={sqc.getIn(['data', 'certificate', 'rf'])}/>

                        </div>
                    </Paper>
                </div>
            </div>

            <SqcRow
                label="Version"
                value={sqc.getIn(['data', 'modem_info', 'sw_version'])}/>

            <SqcRow label="CMTS" value={sqc.getIn(['data', 'modem_info', 'cmts'])}/>

            <SqcRow label="IP" value={sqc.getIn(['data', 'modem_info', 'ipaddress'])}/>

            <SqcRow
                label="Device Type"
                value={sqc.getIn(['data', 'provinfo', 'devicetype'])}/>

            <SqcRow label="Package" value={sqc.getIn(['data', 'provinfo', 'package'])}/>

        </div>
    );
};

SqcPanel.propTypes = {
    sqc: PropTypes.object

};
export default SqcPanel;



// WEBPACK FOOTER //
// ./src/components/equipment/SqcPanel.js